import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { auth as authApi, app as appApi } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        try {
            const raw = localStorage.getItem("linkia_user");
            return raw ? JSON.parse(raw) : null;
        } catch { return null; }
    });
    const [tokensInfo, setTokensInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    const persist = useCallback((u, token) => {
        if (u) localStorage.setItem("linkia_user", JSON.stringify(u));
        else localStorage.removeItem("linkia_user");
        if (token) localStorage.setItem("linkia_token", token);
        setUser(u);
    }, []);

    const refreshMe = useCallback(async () => {
        try {
            const [me, tok] = await Promise.all([authApi.me(), appApi.tokens()]);
            persist(me, null);
            setTokensInfo(tok);
            return me;
        } catch {
            return null;
        }
    }, [persist]);

    useEffect(() => {
        const token = localStorage.getItem("linkia_token");
        if (!token) { setLoading(false); return; }
        refreshMe().finally(() => setLoading(false));
    }, [refreshMe]);

    const login = async ({ email, password, cf_turnstile_token }) => {
        const data = await authApi.login({ email, password, cf_turnstile_token });
        persist(data.user, data.access_token);
        const tok = await appApi.tokens().catch(() => null);
        if (tok) setTokensInfo(tok);
        try { window.dispatchEvent(new Event("linkia-auth-changed")); } catch { /* noop */ }
        return data.user;
    };

    const register = async ({ email, password, name, cf_turnstile_token }) => {
        const data = await authApi.register({ email, password, name, cf_turnstile_token });
        persist(data.user, data.access_token);
        const tok = await appApi.tokens().catch(() => null);
        if (tok) setTokensInfo(tok);
        try { window.dispatchEvent(new Event("linkia-auth-changed")); } catch { /* noop */ }
        return data.user;
    };

    const logout = () => {
        localStorage.removeItem("linkia_token");
        localStorage.removeItem("linkia_user");
        setUser(null);
        setTokensInfo(null);
        try { window.dispatchEvent(new Event("linkia-auth-changed")); } catch { /* noop */ }
    };

    return (
        <AuthContext.Provider value={{ user, tokensInfo, loading, login, register, logout, refreshMe, setTokensInfo }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth precisa estar dentro de <AuthProvider>");
    return ctx;
}
